<div class="procedure">
  <mat-checkbox [(ngModel)]="selected" class="procedure__checkbox" [disabled]="!active">
    {{ type }}
  </mat-checkbox>
  <a *ngIf="active" [href]="procedure.url" target="_blank" class="procedure__body">
    <ng-container [ngTemplateOutlet]="procedureBody"></ng-container>
  </a>
  <div *ngIf="!active" class="procedure__body procedure__body--deleted">
    <ng-container [ngTemplateOutlet]="procedureBody"></ng-container>
  </div>
</div>

<ng-template #procedureBody>
  <mat-icon fontSet="fa" fontIcon="fa-file-pdf-o" class="procedure__icon"></mat-icon>
  <div class="procedure__name">{{ procedure.name }}</div>
  <span *ngIf="changed" class="procedure__change-badge" [matTooltip]="changeTypeTooltip"
        [class.procedure__change-badge--new]="procedure.changeType === ChangeType.Added"
        [class.procedure__change-badge--changed]="procedure.changeType === ChangeType.Changed"
        [class.procedure__change-badge--deleted]="procedure.changeType === ChangeType.Deleted">
      {{ changeType }}
    </span>
</ng-template>
